import { useCallback } from "react";
import { useHistory } from "react-router";

import {
  useStagePageContext,
  useVenueEventContext,
  useVenuePageContext,
} from "Venues/contexts";
import { buildUrl } from "shared/utils";
import { PATHS } from "App/router";

export interface VenueRouteParams {
  venueId?: string;
  stageId?: string;
  hash?: string;
  params?: Record<string, string>;
  removeQueryParams?: boolean;
}

export const useVenueRoute = () => {
  const history = useHistory();
  const { venueId } = useVenuePageContext();
  const { stageId } = useStagePageContext();
  const { eventId } = useVenueEventContext();

  const pushRoute = useCallback(
    (path: string, options?: VenueRouteParams) => {
      (venueId || options?.venueId) &&
        history.push(
          buildUrl(
            path,
            {
              venueId: (options?.venueId || venueId) as string,
              stageId: (options?.stageId || stageId) as string,
              ...options?.params,
            },
            options?.hash,
            // if there's an eventId in the query params, keep it
            !options?.removeQueryParams && eventId ? { eventId } : undefined
          )
        );
    },
    [venueId, stageId, history, eventId]
  );

  const getPath = useCallback(
    (path: string, options?: VenueRouteParams) => {
      if (venueId || options?.venueId) {
        return buildUrl(
          path,
          {
            venueId: (options?.venueId || venueId) as string,
            stageId: (options?.stageId || stageId) as string,
            ...options?.params,
          },
          options?.hash,
          // if there's an eventId in the query params, keep it
          !options?.removeQueryParams && eventId ? { eventId } : undefined
        );
      }
      return PATHS.DASHBOARD;
    },
    [eventId, venueId, stageId]
  );

  return { pushRoute, getPath };
};
